import ContractualAccountDTO from 'features/contracts/dtos/ContractualAccountDTO';
import RoundButton from 'features/shared/components/buttons/RoundButton';
import CommodityIconList from 'features/shared/components/icons/CommodityIconList';
import React from 'react';
import ContractualAccountStatusLabel from 'features/contractualAccounts/components/ContractualAccountStatusLabel';
import { useTranslation } from 'react-i18next';
import styles from './contractulAccountSimplified.module.scss';
import { LocationDescriptor } from 'history';
import { getQueryParams } from 'features/shared/helpers/queryParams';
import { containsFuelingCommodity } from 'features/contracts/helpers/commodityDetailHelper';
import { getContractualAccountDetailRoute } from 'features/shared/helpers/routeHelper';

interface Props {
  account: ContractualAccountDTO;
}

const ContractulAccountSimplified = ({ account }: Props) => {
  // translations
  const { t } = useTranslation(["billings\\enums\\billingCycle"]);
  const tLabels = useTranslation("contractualAccounts\\contractualAccounts").t;
  const tTerms = useTranslation(["shared\\terms"]).t;

  // sub-renders
  const renderAccountName = () => {
    if (account.name) {
      return <>{account.name}</>;
    } else {
      return <span className="d-none d-lg-inline">{tTerms("Undefined")}</span>
    }
  }

  // render
  return (
    <div className="row no-gutters align-items-center">
      <div className="col">
        <div className="row no-gutters align-items-center">
          <div className="col-lg-6">
            <div className="row no-gutters align-items-center">
              <div className="col-lg-5">
                <div className="d-flex">
                  <CommodityIconList
                    commodityDetails={account.commodityDetail!}
                    includeColor
                    className={styles.icons}
                    isProduction={account.isProduction}
                  />
                  <div className="ml-2" title={account.number}>
                    {account.number}
                  </div>
                  <div className="d-lg-none mx-2 my-1 border-right border-dark"></div>
                  <div className="d-lg-none text-muted text-truncate">
                    <span className="mr-1">{tLabels("contractualAccountSimplified.variableSymbol")}:</span>
                    <span>{account.variableSymbol}</span>
                  </div>
                </div>
              </div>
              <div className="col-lg-7 pl-lg-4 pr-lg-3">
                <div className="text-muted text-truncate" title={account.name}>
                  {renderAccountName()}
                </div>
              </div>
            </div>
          </div>
          <div className="d-none d-lg-block col-lg-2">
            {account.variableSymbol}
          </div>
          <div className="col-lg-4 text-center">
            <div className="row no-gutters align-items-center">
              <div className="col-auto col-lg-4">
                <span className="d-lg-none text-muted mr-1">{tLabels("contractualAccountSimplified.invoicing")}:</span>
                {t(account.billingCycle!)}
              </div> 
              <div className="col-auto col-lg-3 px-2 px-lg-0">
                <span className="d-lg-none text-muted mr-1">{tLabels("contractualAccountSimplified.count")}:</span>
                {account.contractCount}
              </div>
              <div className="col-auto col-lg-5">
                <ContractualAccountStatusLabel status={account.contractualAccountStatus!} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-auto pl-2 pl-sm-3">
      <RoundButton
          asLink
          to={getContractualAccountDetailRoute(
            account.contractualAccountId!,
            "contracts",
            containsFuelingCommodity(account.commodityDetail!)
          )}
        />
      </div>
    </div>
  )
}

export default ContractulAccountSimplified;
